import React, { createContext, useState, useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
 
const ProfileContext = createContext();
 
export const ProfileProvider = ({ children }) => {
    const [profilePic, setProfilePic] = useState(null);
    const location = useLocation();
 
    useEffect(() => {
        const storedPic = localStorage.getItem("profile_image");
        if (storedPic) {
            setProfilePic(storedPic);
        } else {
            setProfilePic(null);
        }
    }, [location.pathname]);
 
    useEffect(() => {
        if (profilePic) {
            localStorage.setItem("profile_image", profilePic);
        } else {
            localStorage.removeItem("profile_image");
        }
    }, [profilePic]);
 
    return (
        <ProfileContext.Provider value={{ profilePic, setProfilePic }}>
            {children}
        </ProfileContext.Provider>
    );
};
 
export const useProfile = () => useContext(ProfileContext);
 